// ANX-115 — разбор текста сообщения на ссылки и обычный текст, чтобы рендерить
// кликабельные <a> вместо «голого» URL'а. В панели оператор находится в
// админ-приложении → все ссылки открываются в новой вкладке (_blank), чтобы
// не уводить его из панели.
//
// Безопасность: матчим только http(s):// и www. (схемы javascript:/data: под
// regex не попадают → XSS через href исключён); текст рендерится как data.

const URL_RE = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
// Хвостовая пунктуация не входит в ссылку: "(см. https://x.ru)." → без ")."
const TRAIL_RE = /[.,;:!?)\]}'"»]+$/;

export interface LinkPart {
  text: string;
  /** Если задан — это ссылка; иначе обычный текстовый сегмент. */
  href?: string;
}

/** Разбивает тело сообщения на последовательность текст/ссылка сегментов. */
export function parseLinks(body: string): LinkPart[] {
  const parts: LinkPart[] = [];
  let last = 0;
  for (const m of body.matchAll(URL_RE)) {
    const start = m.index ?? 0;
    let raw = m[0];
    const trail = TRAIL_RE.exec(raw);
    const tail = trail ? trail[0] : '';
    if (tail) raw = raw.slice(0, raw.length - tail.length);
    if (start > last) parts.push({ text: body.slice(last, start) });
    const href = raw.toLowerCase().startsWith('www.') ? 'https://' + raw : raw;
    parts.push({ text: raw, href });
    if (tail) parts.push({ text: tail });
    last = start + m[0].length;
  }
  if (last < body.length) parts.push({ text: body.slice(last) });
  if (parts.length === 0) parts.push({ text: body });
  return parts;
}
